import { takeEvery, select } from 'redux-saga/effects';
import { sendLog } from '@siteground/styleguide';
import { getDebugEvents } from '../../selectors/debug';
import { getChatState } from '../../selectors/chat';

import {
  SUBSEQUENT_SOCKET_CONNECT_RETRIES,
  EXCEEDED_SOCKET_CONNECT_RETRIES,
  SUBSEQUENT_FETCH_CONNECTIONS_RETRIES
} from '../actions/from-client-frontend';

export default function* reconnectLogger() {
  let loggedErrorForSubsequentSocketRetries = false;
  let loggedErrorForSubsequentFetchConnectRetries = false;

  yield takeEvery(EXCEEDED_SOCKET_CONNECT_RETRIES, function* () {
    const debugEvents = yield select(getDebugEvents);
    const state = yield select(getChatState);

    return sendLog({
      error: 'Chat-Error --->>> EXCEEDED_SOCKET_CONNECT_RETRIES',
      errorInfo: {
        componentStack: ''
      },
      data: JSON.stringify({
        agent: window.navigator.userAgent,
        chatState: state,
        debugEvents
      })
    });
  });

  yield takeEvery(SUBSEQUENT_SOCKET_CONNECT_RETRIES, function* () {
    if (loggedErrorForSubsequentSocketRetries) {
      return;
    }

    const debugEvents = yield select(getDebugEvents);
    const state = yield select(getChatState);

    loggedErrorForSubsequentSocketRetries = true;

    return sendLog({
      error: 'Chat-Error --->>> SUBSEQUENT_SOCKET_CONNECT_RETRIES',
      errorInfo: {
        componentStack: ''
      },
      data: JSON.stringify({
        agent: window.navigator.userAgent,
        chatState: state,
        debugEvents
      })
    });
  });

  yield takeEvery(SUBSEQUENT_FETCH_CONNECTIONS_RETRIES, function* () {
    if (loggedErrorForSubsequentFetchConnectRetries) {
      return;
    }

    const debugEvents = yield select(getDebugEvents);
    const state = yield select(getChatState);

    loggedErrorForSubsequentFetchConnectRetries = true;

    return sendLog({
      error: 'Chat-Error --->>> SUBSEQUENT_FETCH_CONNECTIONS_RETRIES',
      errorInfo: {
        componentStack: ''
      },
      data: JSON.stringify({
        agent: window.navigator.userAgent,
        chatState: state,
        debugEvents
      })
    });
  });
}
